import { render, staticRenderFns } from "./DashWriteup.vue?vue&type=template&id=24443273&"
import script from "./DashWriteup.vue?vue&type=script&lang=js&"
export * from "./DashWriteup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports